import request from '@/utils/request';

export function getShopPricePage(query) {
  return request({
    url: '/api/system/shopPrice/queryShopPricePage',
    method: 'post',
    data: query
  });
}

export function getShopPriceList(query) {
  return request({
    url: '/api/system/shopPrice/queryShopPriceList',
    method: 'post',
    data: query
  });
}

export function updateShopPrice(form) {
  return request({
    url: '/api/system/shopPrice/updateShopPrice',
    method: 'post',
    data: form
  });
}

export function saveShopPrice(form) {
  return request({
    url: '/api/system/shopPrice/saveShopPrice',
    method: 'post',
    data: form
  });
}

export function deleteShopPrice(id) {
  return request({
    url: '/api/system/shopPrice/deleteShopPrice',
    method: 'post',
    data: {'id': id}
  });
}

export function getShopPriceById(id) {
  return request({
    url: '/api/system/shopPrice/getShopPrice',
    method: 'post',
    data: {'id': id}
  });
}

/**报价管理详情信息*/
export function queryShopPriceItemPage(query) {
  return request({
    url: '/api/system/shopPriceItem/queryShopPriceItemPage',
    method: 'post',
    data: query
  });
}

export function queryShopPriceItemList(query) {
  return request({
    url: '/api/system/shopPriceItem/queryShopPriceItemList',
    method: 'post',
    data: query
  });
}

export function updateShopPriceItem(form) {
  return request({
    url: '/api/system/shopPriceItem/updateShopPriceItem',
    method: 'post',
    data: form
  });
}

export function saveShopPriceItem(form) {
  return request({
    url: '/api/system/shopPriceItem/saveShopPriceItem',
    method: 'post',
    data: form
  });
}

export function deleteShopPriceItem(id) {
  return request({
    url: '/api/system/shopPriceItem/deleteShopPriceItem',
    method: 'post',
    data: {'id': id}
  });
}

export function getShopPriceItem(id) {
  return request({
    url: '/api/system/shopPriceItem/getShopPriceItem',
    method: 'post',
    data: {'id': id}
  });
}



// WEBPACK FOOTER //
// ./src/api/shopPrice.js